<ng-container *ngIf="vm$ | async as vm">
	<app-container type="card">
		<atomic-party-client-card
			[client]="vm._client"
			[hideIdv]="!isTreefortConnected"
			[kebabOptions]="clientKebabOptions"
			(onKebabSelect)="onClientKebabSelect($event)"
			[pills]="getClientPills(vm._client)"
			[testHook]="testHooks.PartyClientCard"
		></atomic-party-client-card>
		<div
			*ngIf="vm.hasAssociatedContacts"
			class="ml-2 mt-1 flex gap-2 items-center"
		>
			<span>Associated Contacts:</span>
			<ui-button
				preset="EXTRA_LOW_EMPHASIS"
				[label]="vm.associatedContactsButtonText"
				(click)="viewAssociatedContacts()"
				[testHook]="testHooks.VmAssociatedContactsTextButton"
			></ui-button>
		</div>
		<div
			type="dark"
			*ngIf="vm.isGuarantor"
			class="ml-2 mt-2 border rounded-xl border-grey-veryLight bg-grey-lightest py-1 px-2"
		>
			<div *ngFor="let mortgage of vm.guarantorMortgagesNames" class="text-sm">
				{{ mortgage }}
			</div>
			<div *ngIf="!(vm.guarantorMortgagesNames?.length > 0)">
				No mortgages assigned to guarantor
			</div>
		</div>
	</app-container>
</ng-container>
